export const data = {
  orgId: 1,
  positionName: '总经理',
  userNameCn: '黄兴欣',
  positionCode: '903(V5-VN)',
  workYears: '6年',
  honors: '精英',
  isShowHeader: true,
  headerUrl: 'https://www.html.cn/newimg88/2009/05/feiwen8772qqcom_2da5419d.jpg',
  certificationList: [
    {
      certificationName: '机电',
      certificationLevel: '三级'
    },
    {
      certificationName: '服务',
      certificationLevel: '三级'
    }
  ],
  childrenUserInfoList: [
    {
      orgId: 2,
      positionName: '销售经理/总监',
      userNameCn: '刘曦',
      positionCode: '438(V5-VN)',
      workYears: '3年',
      honors: '精英',
      isShowHeader: true,
      headerUrl: 'https://www.html.cn/newimg88/2009/05/feiwen8772qqcom_2da5419d.jpg',
      certificationList: [
        {
          certificationName: '机电',
          certificationLevel: '三级'
        },
        {
          certificationName: '服务',
          certificationLevel: '三级'
        }
      ],
      childrenUserInfoList: [
        {
          orgId: 3,
          positionName: '销售主管/展厅经理',
          userNameCn: '王强',
          positionCode: '441(V5-VN)',
          workYears: '3年',
          honors: '精英',
          certificationList: [
            {
              certificationName: '机电',
              certificationLevel: '三级'
            },
            {
              certificationName: '服务',
              certificationLevel: '三级'
            }
          ],
          childrenUserInfoList: [
            {
              orgId: 4,
              positionName: '销售组长',
              userNameCn: '刘禹锡',
              positionCode: '104(V5-VN)',
              workYears: '3年',
              honors: '精英',
              isGroupLeader: true,
              groupName: '核心A组',
              certificationList: [
                {
                  certificationName: '机电',
                  certificationLevel: '三级'
                },
                {
                  certificationName: '服务',
                  certificationLevel: '三级'
                }
              ],
              childrenUserInfoList: [
              ],
              groupList: [
                {
                  orgId: 5,
                  positionName: '新车销售顾问',
                  userNameCn: '李晓宇',
                  positionCode: '903(V5-VN)',
                  workYears: '3年',
                  honors: '精英',
                  partTimeJob: true,
                  certificationList: [
                    {
                      certificationName: '机电A',
                      certificationLevel: '三级'
                    },
                    {
                      certificationName: '服务B',
                      certificationLevel: '三级'
                    }
                  ],
                  childrenUserInfoList: []
                },
                {
                  orgId: 6,
                  positionName: '新车销售顾问',
                  userNameCn: '刘肇铨',
                  positionCode: '104(V5-VN)',
                  workYears: '3年',
                  honors: '精英',
                  certificationList: [
                    {
                      certificationName: '机电',
                      certificationLevel: '三级'
                    },
                    {
                      certificationName: '服务',
                      certificationLevel: '三级'
                    }
                  ],
                  childrenUserInfoList: []
                }
              ]
            },
            {
              orgId: 4,
              positionName: '销售组长',
              userNameCn: '刘禹锡',
              positionCode: '104(V5-VN)',
              workYears: '3年',
              honors: '精英',
              isGroupLeader: true,
              groupName: '核心B组',
              certificationList: [
                {
                  certificationName: '机电',
                  certificationLevel: '三级'
                },
                {
                  certificationName: '服务',
                  certificationLevel: '三级'
                }
              ],
              childrenUserInfoList: [
              ],
              groupList: [
                {
                  orgId: 5,
                  positionName: '新车销售顾问',
                  userNameCn: '李晓宇',
                  positionCode: '903(V5-VN)',
                  workYears: '3年',
                  honors: '精英',
                  partTimeJob: true,
                  certificationList: [
                    {
                      certificationName: '机电A',
                      certificationLevel: '三级'
                    },
                    {
                      certificationName: '服务B',
                      certificationLevel: '三级'
                    }
                  ],
                  childrenUserInfoList: []
                },
                {
                  orgId: 6,
                  positionName: '新车销售顾问',
                  userNameCn: '刘肇铨',
                  positionCode: '104(V5-VN)',
                  workYears: '3年',
                  honors: '精英',
                  certificationList: [
                    {
                      certificationName: '机电',
                      certificationLevel: '三级'
                    },
                    {
                      certificationName: '服务',
                      certificationLevel: '三级'
                    }
                  ],
                  childrenUserInfoList: []
                }
              ]
            }
          ]
        },
        {
          orgId: 7,
          positionName: '销售计划主管',
          userNameCn: '张兴华',
          positionCode: '451(V5-VN)',
          workYears: '3年',
          honors: '精英',
          partTimeJob: true,
          certificationList: [
            {
              certificationName: '机电',
              certificationLevel: '三级'
            },
            {
              certificationName: '服务',
              certificationLevel: '三级'
            },
            {
              certificationName: '钣金',
              certificationLevel: '三级'
            }
          ],
          childrenUserInfoList: [
            {
              orgId: 8,
              positionName: '销售计划专员',
              userNameCn: '张国庆',
              positionCode: '104(V5-VN)',
              workYears: '3年',
              honors: '精英',
              certificationList: [
                {
                  certificationName: '机电',
                  certificationLevel: '三级'
                },
                {
                  certificationName: '服务',
                  certificationLevel: '三级'
                }
              ],
              childrenUserInfoList: [

              ]
            }
          ]
        }
      ]
    },
    {
      orgId: 9,
      positionName: '售后经理/总监',
      userNameCn: '赵丽霞',
      positionCode: '950(V5-VN)',
      workYears: '6年',
      honors: '精英',
      isShowHeader: true,
      headerUrl: 'https://www.html.cn/newimg88/2009/05/feiwen8772qqcom_2da5419d.jpg',
      certificationList: [
        {
          certificationName: '机电',
          certificationLevel: '三级'
        },
        {
          certificationName: '服务',
          certificationLevel: '三级'
        }
      ],
      childrenUserInfoList: [
        {
          orgId: 10,
          positionName: '服务经理1',
          userNameCn: '王兴',
          positionCode: '001(V5-VN)',
          workYears: '3年',
          honors: '精英',
          brotherList: [
            {
              orgId: 13,
              positionName: '服务顾问',
              userNameCn: '刘强',
              positionCode: '040(V5-VN)',
              workYears: '3年',
              honors: '精英',
              certificationList: [
                {
                  certificationName: '机电',
                  certificationLevel: '三级'
                },
                {
                  certificationName: '服务',
                  certificationLevel: '三级'
                }
              ],
              childrenUserInfoList: [

              ]
            },
            {
              orgId: 13,
              positionName: '服务顾问',
              userNameCn: '刘强',
              positionCode: '040(V5-VN)',
              workYears: '3年',
              honors: '精英',
              certificationList: [
                {
                  certificationName: '机电',
                  certificationLevel: '三级'
                },
                {
                  certificationName: '服务',
                  certificationLevel: '三级'
                }
              ],
              childrenUserInfoList: [

              ]
            },
            {
              orgId: 13,
              positionName: '服务顾问',
              userNameCn: '刘强',
              positionCode: '040(V5-VN)',
              workYears: '3年',
              honors: '精英',
              certificationList: [
                {
                  certificationName: '机电',
                  certificationLevel: '三级'
                },
                {
                  certificationName: '服务',
                  certificationLevel: '三级'
                }
              ],
              childrenUserInfoList: [

              ]
            }
          ],
          certificationList: [
            {
              certificationName: '机电',
              certificationLevel: '三级'
            },
            {
              certificationName: '服务',
              certificationLevel: '三级'
            }
          ],
          childrenUserInfoList: [
          ]
        },
        {
          orgId: 10,
          positionName: '服务经理',
          userNameCn: '王兴',
          positionCode: '001(V5-VN)',
          workYears: '3年',
          honors: '精英',
          certificationList: [
            {
              certificationName: '机电',
              certificationLevel: '三级'
            },
            {
              certificationName: '服务',
              certificationLevel: '三级'
            }
          ],
          childrenUserInfoList: [
            {
              orgId: 11,
              positionName: '服务顾问主管',
              userNameCn: '张强',
              positionCode: '041(V5-VN)',
              workYears: '3年',
              honors: '精英',
              certificationList: [
                {
                  certificationName: '机电',
                  certificationLevel: '三级'
                },
                {
                  certificationName: '服务',
                  certificationLevel: '三级'
                }
              ],
              childrenUserInfoList: [
                {
                  orgId: 12,
                  positionName: '服务顾问',
                  userNameCn: '刘晓',
                  positionCode: '040(V5-VN)',
                  workYears: '3年',
                  honors: '精英',
                  partTimeJob: true,
                  certificationList: [
                    {
                      certificationName: '机电',
                      certificationLevel: '三级'
                    },
                    {
                      certificationName: '服务',
                      certificationLevel: '三级'
                    }
                  ],
                  childrenUserInfoList: [

                  ]
                },
                {
                  orgId: 13,
                  positionName: '服务顾问',
                  userNameCn: '刘强',
                  positionCode: '040(V5-VN)',
                  workYears: '3年',
                  honors: '精英',
                  certificationList: [
                    {
                      certificationName: '机电',
                      certificationLevel: '三级'
                    },
                    {
                      certificationName: '服务',
                      certificationLevel: '三级'
                    }
                  ],
                  childrenUserInfoList: [

                  ]
                }
              ]
            }
          ]
        },
        {
          orgId: 14,
          positionName: '保险经理',
          userNameCn: '刘岚',
          positionCode: '671(V5-VN)',
          workYears: '3年',
          honors: '精英',
          certificationList: [
            {
              certificationName: '机电',
              certificationLevel: '三级'
            },
            {
              certificationName: '服务',
              certificationLevel: '三级'
            }
          ],
          childrenUserInfoList: [
            {
              orgId: 15,
              positionName: '新车保险主管',
              userNameCn: '张强',
              positionCode: '655(V5-VN)',
              workYears: '3年',
              honors: '精英',
              certificationList: [
                {
                  certificationName: '机电',
                  certificationLevel: '三级'
                },
                {
                  certificationName: '服务',
                  certificationLevel: '三级'
                }
              ],
              childrenUserInfoList: [
                {
                  orgId: 16,
                  positionName: '新车保险专员',
                  userNameCn: '刘玲玲',
                  positionCode: '651(V5-VN)',
                  workYears: '3年',
                  honors: '精英',
                  certificationList: [
                    {
                      certificationName: '机电',
                      certificationLevel: '三级'
                    },
                    {
                      certificationName: '服务',
                      certificationLevel: '三级'
                    }
                  ],
                  childrenUserInfoList: [

                  ]
                },
                {
                  orgId: 17,
                  positionName: '新车保险专员',
                  userNameCn: '罗晓晓',
                  positionCode: '040(V5-VN)',
                  workYears: '3年',
                  honors: '精英',
                  certificationList: [
                    {
                      certificationName: '机电',
                      certificationLevel: '三级'
                    },
                    {
                      certificationName: '服务',
                      certificationLevel: '三级'
                    }
                  ],
                  childrenUserInfoList: [

                  ]
                }
              ]
            },
            {
              orgId: 18,
              positionName: '续保主管',
              userNameCn: '刘晓芳',
              positionCode: '654(V5-VN)',
              workYears: '3年',
              honors: '精英',
              certificationList: [
                {
                  certificationName: '机电',
                  certificationLevel: '三级'
                },
                {
                  certificationName: '服务',
                  certificationLevel: '三级'
                }
              ],
              childrenUserInfoList: [
                {
                  orgId: 19,
                  positionName: '续保专员',
                  userNameCn: '刘小青',
                  positionCode: '653(V5-VN)',
                  workYears: '3年',
                  honors: '精英',
                  certificationList: [
                    {
                      certificationName: '机电',
                      certificationLevel: '三级'
                    },
                    {
                      certificationName: '服务',
                      certificationLevel: '三级'
                    }
                  ],
                  childrenUserInfoList: [

                  ]
                },
                {
                  orgId: 20,
                  positionName: '续保专员',
                  userNameCn: '王芳',
                  positionCode: '653(V5-VN)',
                  workYears: '3年',
                  honors: '精英',
                  certificationList: [
                    {
                      certificationName: '机电',
                      certificationLevel: '三级'
                    },
                    {
                      certificationName: '服务',
                      certificationLevel: '三级'
                    }
                  ],
                  childrenUserInfoList: [

                  ]
                }
              ]
            }
          ]
        }
      ]
    }

  ]
}
